import CategoryCardImage from './CategoryCardImage';

function CategoryCard({
  group,
  selectedCount,
  isOpen,
  hasSynergy,
  onToggle,
}) {
  return (
    <button
      type="button"
      className={`category-card${isOpen ? ' category-card--open' : ''}${
        hasSynergy && !isOpen ? ' category-card--synergy' : ''
      }`}
      onClick={() => onToggle(group.key)}
      aria-expanded={isOpen}
    >
      <CategoryCardImage
        groupKey={group.key}
        emoji={group.emoji}
        label={group.label}
        imageAlt={group.imageAlt}
      />
      <div className="category-card__body">
        <span className="category-card__name">{group.label}</span>
        <span className="category-card__tagline">{group.tagline}</span>
        <span className="category-card__count">
          {group.ingredients.length} ingredients
        </span>
        {selectedCount > 0 && (
          <span className="category-card__badge">{selectedCount} selected</span>
        )}
      </div>
    </button>
  );
}

export default CategoryCard;
